import { trackMixpanelEvent } from '../utils/general';
import { SLACK_CLIENT_ID } from '../utils/consts';

export const TRANSLATION_KEY = 'STATIC.PAGES.AI_WATCHLIST';

export const HEARTBEAT_INTERVAL_MS = 30000;

export const TOAST_AUTO_CLOSE_MS = 4000;

export const MONITOR_VERDICT_EVENT = 'data-monitor-verdict';

export const PROMPT_MAX_LENGTH = 8000;

export const PROMPT_PREVIEW_MAX_LENGTH = 200;

export const MONITOR_TITLE_MAX_LENGTH = 50;

export const MONITOR_STATUS = {
    IDLE: 'idle',
    QUEUED: 'queued',
    RUNNING: 'running',
    PAUSED: 'paused',
    AUTO_PAUSED: 'auto_paused',
};

// Both flavours render as a paused card; only the resume dialog tells them apart.
export const isPausedStatus = status => status === MONITOR_STATUS.PAUSED || status === MONITOR_STATUS.AUTO_PAUSED;

export const VERDICT_OUTCOMES = {
    SUCCESS: 'success',
    PROMPT_UNCLEAR: 'prompt_unclear',
    NO_VERDICT: 'no_verdict',
    ERROR: 'error',
};

export const SENTIMENTS = {
    HEADS_UP: 'heads_up',
    GOOD_NEWS: 'good_news',
    NEUTRAL: 'neutral',
};

export const VIEW_TYPES = {
    STATS: 'stats',
    BREAKDOWN: 'breakdown',
    TREND: 'trend',
};

export const BREAKDOWN_VARIANTS = {
    LIST: 'list',
    TABLE: 'table',
};

export const METRIC_TONES = {
    GOOD: 'good',
    BAD: 'bad',
    NEUTRAL: 'neutral',
};

export const WATCHLIST_FILTERS = {
    ALL: 'all',
    HEADS_UP: 'heads_up',
    GOOD_NEWS: 'good_news',
    FLAGGED: 'flagged',
    PROMPT_UNCLEAR: 'prompt_unclear',
};

// Starting points offered inside the composer. Each key resolves to a COMPOSER.SUGGESTIONS entry
// holding the chip label, the monitor name and the prompt the chip writes into the field.
export const COMPOSER_SUGGESTIONS = ['CPI_SPIKE', 'BUDGET_PACING', 'CREATIVE_FATIGUE', 'MISSING_COST'];

export const CARD_STATES = {
    PAUSED: 'paused',
    RUNNING: 'running',
    QUEUED: 'queued',
    BUSY: 'busy',
    VERDICT: 'verdict',
};

export const RUN_FINISH_REASONS = {
    STOP: 'stop',
    CANCELLED: 'cancelled',
    ERROR: 'error',
};

export const SCHEDULE_FREQUENCIES = {
    HOURLY: 'hourly',
    DAILY: 'daily',
    WEEKLY: 'weekly',
};

export const DEFAULT_SCHEDULE = {
    frequency: SCHEDULE_FREQUENCIES.WEEKLY,
    days: [1],
    hour: 7,
    minute: 0,
};

export const WEEK_DAY_NUMBERS = Array.from({ length: 7 }, (_, i) => i + 1);

export const RUN_ERROR_TOAST_KEYS = {
    'Monitor is paused': `${TRANSLATION_KEY}.TOASTS.RUN_PAUSED`,
    'Monitor check already in progress': `${TRANSLATION_KEY}.TOASTS.RUN_IN_PROGRESS`,
};

export const MENU_ACTION_ICONS = {
    EDIT_PROMPT: 'pencil',
    PAUSE: 'player-pause',
    RESUME: 'player-play',
    DISCONNECT_SLACK: 'unlink',
    REMOVE: 'trash',
};

export const SLACK_CONNECTED_PARAM = 'slack_connected';
export const SLACK_ERROR_PARAM = 'slack_error';
export const SLACK_AUTHORIZATION_NOT_COMPLETED = 'authorization_not_completed';

export const buildMonitorSlackAuthUrl = monitorId => {
    const params = new URLSearchParams({
        scope: 'chat:write,incoming-webhook',
        client_id: SLACK_CLIENT_ID,
        redirect_uri: `${window.location.origin}/interactive-service/slack`,
        state: monitorId,
    });
    return `https://slack.com/oauth/v2/authorize?${params}`;
};

export const AI_WATCHLIST_EVENT_PREFIX = 'Watchlist';

export const WATCHLIST_EVENTS = {
    RUN_NOW: 'Run Now',
    RUN_ALL: 'Run All',
    OPEN_THREAD: 'Open Thread',
    ADD_MONITOR: 'Add Monitor',
    DELETE_MONITOR: 'Delete Monitor',
    PAUSE_MONITOR: 'Pause Monitor',
    RESUME_MONITOR: 'Resume Monitor',
    RESUME_AUTO_PAUSED: 'Resume Auto Paused',
    KEEP_AUTO_PAUSED: 'Keep Auto Paused',
    EDIT_PROMPT: 'Edit Prompt',
    EDIT_TITLE: 'Edit Title',
    SUGGEST_TITLE: 'Suggest Title',
    CHANGE_SCHEDULE: 'Change Schedule',
    SLACK_CLICKED: 'Slack Clicked',
    SLACK_CONNECTED: 'Slack Connected',
    SLACK_DISCONNECTED: 'Slack Disconnected',
    RESTORE_DEFAULTS: 'Restore Defaults',
    FILTER: 'Filter Monitors',
    COMPOSER_SUGGESTION: 'Composer Suggestion',
    ALERT_CLICKED: 'Open Alert',
    ALERT_EXPANDED: 'Expand Alert',
    ALERTS_MARK_ALL_READ: 'Mark Alerts Read',
    ALERT_SNOOZED: 'Snooze Alert',
    ALERTS_BANNER_REVIEW: 'Review Missed Alerts',
};

export const trackWatchlistEvent = (eventName, params) =>
    trackMixpanelEvent(AI_WATCHLIST_EVENT_PREFIX, eventName, params);
